import React, { useState } from "react";
import "../components/doctorSpecialistHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const DoctorSpecialistHeader = ({
  onAddSpecialistClicked,
  onSearchSpecialistEdited,
}) => {

  const [searchValue, setSearchValue] = useState(localStorage.getItem("searchValue"));
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault()
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
 localStorage.setItem("searchValue",searchValue)
      e.preventDefault();
      if (searchValue.length > 3) {
         onSearchSpecialistEdited(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
         onSearchSpecialistEdited(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="doctor-specialist-header-container">
      <button
        className="add-doctor-specialist-button"
        onClick={onAddSpecialistClicked}
      >
        <FaPlusCircle />
        Tambah Poli Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Poli"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          />
          {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default DoctorSpecialistHeader;
